module.exports = __webpack_public_path__ + "assets/img/fb_top2.aaf931c0.png";